/**
 * 旅游产品模块接口
 * @description 产品详情、库存管理、产品订单等相关接口
 */

import axios, { GET, POST } from "@/utils/request";
import Api from "../api";
import * as Request from "../request.type";
import * as ResponseData from "../response.type";

/**
 * 获取打印门票url地址
 * @returns 获取打印门票
 */
export const Http_getApiTicket = async (
  /** 订单ID */
  id: number
) => {
  return await axios.get(Api.GET_APITICKET, {
    params: {
      id,
    },
  });
};

/**
 * 修改旅游产品订单供应商订单号
 */
export const Http_postOrderInfoUpdate = async (
  params: Request.ProdcutOrderInfoUpdateParams
) => {
  return await axios.post(Api.POST_PRODUCT_ORDER_INFO_UPDATE, params);
};

/**
 * 获取取卡串码
 */
export const Http_getProductPrintCardNo = async (
  /** 订单ID */
  id: number
) => {
  return await axios.get(Api.GET_PRODUCT_PRINT_CARD_NO, {
    params: {
      id,
    },
  });
};

/**
 * 获取旅游产品收据-加密order
 */
export const Http_getTourReceipt = async (
  /** 加密订单ID */
  orderId: string
): Promise<{ code: number; data: ResponseData.Receipt; message?: string }> => {
  return await axios.get(Api.GET_Tour_RECEIPT, {
    params: {
      orderId,
    },
  });
};

/**
 * 获取旅游产品教练信息-加密order
 */
export const Http_getCoachMessage = async (
  /** 加密订单ID */
  orderId: string
) => {
  return await axios.get<ResponseData.CoachMessage>(
    Api.GET_Tour_COACH_MESSAGE,
    {
      params: {
        orderId,
      },
    }
  );
};

// ==================== 西九文化区模块 ====================

/**
 * 查询API套票路线列表（按 packTypeCode 筛选）
 * @author Alfie
 */
export const Http_getPackRouteList = async (params: {
  packTypeCode: string;
}) => {
  return await GET<{ id: number; nameCn: string }[]>(
    Api.GET_PACK_ROUTE_SHORT_LIST,
    params
  );
};

/**
 * 查询API套票产品列表（按 packTypeCode 筛选）
 * @author Alfie
 */
export const Http_getPackProducts = async (params: {
  packTypeCode: string;
  routeId?: number | string;
  startDate?: string;
}) => {
  return await GET<{ id: number; nameCn: string }[]>(
    Api.GET_PACK_PRODUCTS,
    params
  );
};

/**
 * 查询套票产品价格及场次信息
 * @author Alfie
 */
export const Http_getPackProductInfo = async (params: {
  id: number;
  useDate: string;
}) => {
  return await GET<any>(Api.GET_TOUR_PRODUCT_DETAILS, params);
};

/**
 * 查询西九文化区子分类列表
 * @author Alfie
 */
export const Http_getWestkCategoryList = async () => {
  return await GET<ResponseData.WestkCategoryItem[]>(Api.GET_WESTK_CATEGORY);
};

/**
 * 查询西九文化区门票列表（单售）
 * @author Alfie
 */
export const Http_getWestkProducts = async (params: {
  /** 子分类 ID */
  categoryId: number;
  /** 使用日期，格式 yyyy-MM-dd */
  startDate: string;
}) => {
  return await GET<any[]>(Api.GET_WESTK_PRODUCTS, params);
};

/**
 * 后台-查询西九文化区可导入产品列表
 * @author Alfie
 */
export const Http_getWestkImportProducts = async () => {
  return await GET<ResponseData.WestkImportProductItem[]>(
    Api.GET_WESTK_IMPORT_PRODUCTS
  );
};

/**
 * 后台-确认导入选中的西九文化区产品
 * @author Alfie
 */
export const Http_postWestkImportConfirm = async (params: {
  productList: { programId: number; ticketTypeId: number }[];
}) => {
  return await POST<void, typeof params>(Api.POST_WESTK_IMPORT_CONFIRM, params);
};
